// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const SlideHorizontalIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16 18a1 1 0 01-1-1V7a1 1 0 012 0v10a1 1 0 01-1 1zm-4 0a1 1 0 01-1-1V7a1 1 0 012 0v10a1 1 0 01-1 1zm-4 0a1 1 0 01-1-1V7a1 1 0 012 0v10a1 1 0 01-1 1z"/></svg>'} />;

SlideHorizontalIcon.displayName = 'SlideHorizontalIcon';

export default SlideHorizontalIcon;
